import React, { Component } from 'react';
import classNames from 'classnames';
import { withContext } from '../utils/StateProvider';
import FacilityFrame from './facilityFrame';
import FacilityCharacters from './facilityCharacters';
import { itemName, itemSummary } from '../utils/items';
import { buyPrice, sellPrice, haggle } from '../utils/services';

// The market. One character stands at the counter: the merchant shows them
// what they are carrying, and names a price to suit how well they are liked.
class Market extends Component {

  handleKeydown = (e) => {
    const { party, chooseFacilityCharacter } = this.props.context;
    const slot = parseInt(e.key, 10) - 1;
    if (slot >= 0 && slot < party.length) chooseFacilityCharacter(slot);
  }

  // How the merchant is treating this character, in plain words
  standing(buyer) {
    const rate = haggle(buyer);
    if (rate < 0.97) return `${buyer.name} is well liked here: ${Math.round((1 - rate) * 100)}% off`;
    if (rate > 1.03) return `the merchant has little time for ${buyer.name}: ${Math.round((rate - 1) * 100)}% more`;
    return `${buyer.name} gets the usual price`;
  }

  render() {
    const { facility, shopStock, party, facilityCharacter, gold, buyItem, sellItem } = this.props.context;
    if (facility !== 'market') return null;
    const stock = shopStock || [];
    const buyer = party[facilityCharacter];

    return (
      <FacilityFrame
        title="The Market"
        quote='"Best prices in town. Ask anyone, so long as you ask me."'
        hint="Click a name or press 1-6 to send someone else to the counter"
        onKey={this.handleKeydown}
      >
        <FacilityCharacters />
        <div className="facility-standing">{this.standing(buyer)}</div>

        <div className="market-columns">
          <div className="market-column">
            <h2>On the shelves</h2>
            {stock.map((item) => {
              const price = buyPrice(item, buyer);
              return (
                <div key={item.id} className={classNames('training-row', { ready: gold >= price })}>
                  <div className="training-who">
                    <div className="training-name">{itemName(item)}</div>
                    <div className="sheet-muted">{itemSummary(item)}</div>
                  </div>
                  <button
                    className={classNames('menu-button', 'small', { disabled: gold < price })}
                    onClick={() => buyItem(item.id)}
                  >
                    BUY · {price}g
                  </button>
                </div>
              );
            })}
            {!stock.length && <div className="sheet-muted sheet-empty">The shelves are bare.</div>}
          </div>

          <div className="market-column">
            <h2>{buyer.name}'s pack</h2>
            {buyer.backpack.map((item) => (
              <div key={item.id} className="training-row">
                <div className="training-who">
                  <div className="training-name">{itemName(item)}</div>
                  <div className="sheet-muted">{itemSummary(item)}</div>
                </div>
                <button
                  className="menu-button small"
                  onClick={() => sellItem(facilityCharacter, item.id)}
                >
                  SELL · {sellPrice(item, buyer)}g
                </button>
              </div>
            ))}
            {!buyer.backpack.length && (
              <div className="sheet-muted sheet-empty">
                {buyer.name} is carrying nothing loose. Gear being worn has to be taken off on the
                character sheet before it can be sold.
              </div>
            )}
          </div>
        </div>
      </FacilityFrame>
    );
  }
}

export default withContext(Market);
